import React from "react";
import logo from '../Assets/Susana_LOGO.png';

 export function Logo() {
    return (
        <img src={logo} alt="icon"  className ="icons" />
    );
}